






























































import { Component, Vue } from 'vue-property-decorator';
import NavBar from '@/shared/components/NavBar.vue';

@Component({
  components: {
    NavBar,
  },
})

export default class App extends Vue {
  healthCheck: string = '';

  hasLoadedHealthCheck: boolean = false;

  mounted() {
    fetch(`${process.env.VUE_APP_API_URL}/health-check/v1/check`)
      .then(async (data) => {
        this.healthCheck = await data.json();
        this.hasLoadedHealthCheck = true;
      });
  }
}
